//
// InteractionElementReference.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "../visualElements/VisualElement";
import "./InteractionPurpose";
import "../dataDefinition/DataDefinition";
import "../dataDefinition/ResultDefinition";
import "./StyleTarget";

var InteractionElementReference = createModule("BIRD::InteractionElementReference", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        styleTargets: [1],
        data: 1,
        purpose: 4,
        resultDefinition: 1,
        variable: 7,
        visualElement: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default InteractionElementReference;
